// ---------------------------------------------------------------
// Customer-defined alert rules. Pick a data point, a condition, a
// threshold — the alert watcher checks every vehicle against them.
// ---------------------------------------------------------------

const KEY = 'dd-custom-alerts';
const num = (x) => (x == null ? null : Number(x));

// Every data point a rule can watch, with how to read it from a position.
export const METRICS = [
  { key: 'speed', label: 'Speed', unit: 'mph', get: (p) => (p.speed || 0) * 1.15078 },
  { key: 'rpm', label: 'Engine RPM', unit: 'rpm', get: (p) => num(p.attributes.io36) },
  { key: 'coolant', label: 'Coolant temperature', unit: '°C', get: (p) => num(p.attributes.io32) },
  { key: 'fuel', label: 'Fuel level', unit: '%', get: (p) => num(p.attributes.io48) },
  { key: 'engineLoad', label: 'Engine load', unit: '%', get: (p) => num(p.attributes.io31) },
  { key: 'throttle', label: 'Throttle position', unit: '%', get: (p) => num(p.attributes.io41) },
  { key: 'vbat', label: 'Vehicle battery', unit: 'V', get: (p) => num(p.attributes.power) },
  { key: 'dbat', label: 'Tracker battery', unit: 'V', get: (p) => num(p.attributes.battery) },
  { key: 'ambient', label: 'Outside temperature', unit: '°C', get: (p) => num(p.attributes.io53) },
  { key: 'sats', label: 'Satellites', unit: '', get: (p) => num(p.attributes.sat) },
  { key: 'signal', label: 'Signal strength (0–5)', unit: '', get: (p) => num(p.attributes.rssi) },
  { key: 'faults', label: 'Active fault codes', unit: '', get: (p) => num(p.attributes.io30) },
];

export const OPS = [
  { key: 'gt', label: 'is above (>)', test: (a, b) => a > b },
  { key: 'gte', label: 'is at or above (≥)', test: (a, b) => a >= b },
  { key: 'lt', label: 'is below (<)', test: (a, b) => a < b },
  { key: 'lte', label: 'is at or below (≤)', test: (a, b) => a <= b },
  { key: 'eq', label: 'equals (=)', test: (a, b) => a === b },
];

export function getRules() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}
export function saveRules(rules) { localStorage.setItem(KEY, JSON.stringify(rules)); }

export function evaluateCustomRules(devices, positions) {
  const rules = getRules().filter((r) => r.enabled !== false);
  const out = [];
  devices.forEach((d) => {
    const p = positions.find((x) => x.deviceId === d.id);
    if (!p) return;
    rules.forEach((rule) => {
      if (rule.deviceId && rule.deviceId !== 'all' && String(rule.deviceId) !== String(d.id)) return;
      const metric = METRICS.find((m) => m.key === rule.metric);
      const op = OPS.find((o) => o.key === rule.op);
      if (!metric || !op) return;
      const val = metric.get(p);
      if (val == null) return;
      if (op.test(val, Number(rule.value))) {
        const posKey = p.id || p.fixTime;
        out.push({
          key: `custom:${rule.id}:${d.id}:${posKey}`,
          entity: d.name, severity: rule.severity || 'warn', icon: '🔔',
          title: rule.name,
          info: `${d.name}: ${metric.label} is ${Math.round(val)}${metric.unit} — your rule: ${metric.label} ${op.label} ${rule.value}${metric.unit}.`,
        });
      }
    });
  });
  return out;
}
